import { combineReducers } from "redux-immutable";

import StudentParentsStateSlice from "../models/StudentParentsStateSlice";
import studentParentsReducer from "./state";
import studentParentsMetaReducer from "./state/meta";

export default combineReducers(
  {
    studentParents: studentParentsReducer,
    meta: studentParentsMetaReducer
  },
  () => new StudentParentsStateSlice() as any
);
